<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-8 col-12 offset-lg-4 offset-md-3 offset-sm-2 offset-0 mt-3">

                <div class="card">
                    <form class="card-body">
                        <!-- auth header logo -->
                        <app-header></app-header>

                        <!-- display alert message desktop view -->
                        <div v-if="msg !== ''" :class="`alert alert-${color} text-center mb-n4 mt-3 p-1`" role="alert">
                            <i class="fas fa-exclamation-circle"></i> {{ msg }}
                        </div>

                        <div class="mt-5 text-center">
                            <input type="password" v-model="passcode" ref="passcode" placeholder="portal passcode" 
                            class="form-control form-control-lg text-center no-lines bg-white mb-3">
                            <span @click.prevent="exitShopFxn" class="loadn btn btn-light bg-silver text-danger">Exit</span>
                            <button @click.prevent="unlockShopFxn" class="loadn btn btn-dark-green ml-2">Grant Access</button>
                        </div>
                    </form>
                    <div class="text-center font-weight-bold">
                        <hr>
                        <span @click="forgotPasscodeFxn" class="clickable">Forgot Passcode</span>
                    </div>
                    <p class="text-dark-green text-center mt-3">
                        <router-link :to="{ name: 'home' }">&copy; aNewItem</router-link>
                    </p>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { webpageTitle } from '@/store/dry'

import Header from '../shared/Header.vue'
import LayoutAuth from '@/layouts/Auth.vue' 

export default {
    name: "LockScreen",
    data() {
        return {
            passcode: '',
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['fetchShop', 'exitShop', 'forgotPasscode']),
        unlockShopFxn() {
            if(this.passcode === ''){ this.msg = "Your shop passcode is required!"; return }
            let userObj = {
                userId: this.user._id,
                passcode: this.passcode
            }
            this.fetchShop(userObj)
            .then((data) => {
                if(!data.error){
                    this.color = "success" 
                    this.passcode = ''
                    this.$router.push({
                        name: 'dashboard'
                    }).catch((e) => {})
                }
                this.msg = data.msg
            }).catch((e) => {
                this.passcode = ''
                this.msg = "We are having issues reaching our resoruces at this time. Check back soon."
            })
        },
        exitShopFxn() {
            this.exitShop()
            .then(() => {
                this.passcode = ''
                this.$router.push({
                    name: 'profile'
                }).catch((e) => {})
            }).catch((e) => {
                this.msg = "sorry, we are unable to exit your shop at this time. Try again!"
                this.passcode = ''
            })
        },
        forgotPasscodeFxn() {
            let userObj = {
                userId: this.user._id,
                email: this.user.email
            }
            this.forgotPasscode(userObj)
            .then((data) => {
                if(!data.error) {
                    this.color = "success"
                    this.passcode = ""
                }
                this.msg = data.msg
            })
            .catch((e) => {
                this.msg = "sorry, we are unable to process your request this time. Try again!"
                this.passcode = ''
            })
        }
    },
    computed: {
        ...mapGetters(['user'])
    },
    components: {
        appHeader: Header
    },
    created() {
        webpageTitle(`Lock screen`)
        this.$emit('update:layout', LayoutAuth);
    }
}
</script>